import { render } from "./LogicWaitEditor.vue?vue&type=template&id=039ed724&scoped=true"
import script from "./LogicWaitEditor.vue?vue&type=script&lang=js"
export * from "./LogicWaitEditor.vue?vue&type=script&lang=js"

import "./LogicWaitEditor.vue?vue&type=style&index=0&id=039ed724&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039ed724"]])

export default __exports__